import { render, staticRenderFns } from "./PppiBlocStat.vue?vue&type=template&id=0461b2a5&scoped=true"
import script from "./PppiBlocStat.vue?vue&type=script&lang=js"
export * from "./PppiBlocStat.vue?vue&type=script&lang=js"
import style0 from "./PppiBlocStat.vue?vue&type=style&index=0&id=0461b2a5&prod&lang=css"
import style1 from "./PppiBlocStat.vue?vue&type=style&index=1&id=0461b2a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0461b2a5",
  null
  
)

export default component.exports